import { render, staticRenderFns } from "./vipList.vue?vue&type=template&id=a391c05e&scoped=true"
import script from "./vipList.vue?vue&type=script&lang=js"
export * from "./vipList.vue?vue&type=script&lang=js"
import style0 from "./vipList.vue?vue&type=style&index=0&id=a391c05e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a391c05e",
  null
  
)

export default component.exports